export default __webpack_public_path__ + "static/media/task_swipe_to_delete.cbf89b6e.png";